import { render } from "./DownloadIcon.vue?vue&type=template&id=06bab23c&scoped=true"
import script from "./DownloadIcon.vue?vue&type=script&lang=js"
export * from "./DownloadIcon.vue?vue&type=script&lang=js"

import "./DownloadIcon.vue?vue&type=style&index=0&id=06bab23c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06bab23c"]])

export default __exports__